<template>
  <div class="Contact">
    <Hero class="lift">
      <h1>{{ $t('title') }}</h1>
    </Hero>
    <SectionOffices />
  </div>
</template>

<script>
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
import SectionOffices from 'views/components/SectionOffices'

export default {
  mixins: [
    Meta(require('@/assets/social/about-us.jpg')),
  ],
  components: { Hero, SectionOffices },
}
</script>

<style lang="scss">
.Contact {
  background-color: $white-bis;

  .Hero {
    background-color: $black;
    background-image: url('../../../assets/ellipses.png');
    background-position: right;
    background-repeat: no-repeat;
    background-size: 60%;
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "title": {
        "complement": "Nogrid",
        "inner": "Kontaktai",
        "separator": "-"
      },
      "description": "Susisiekite su mumis. Mes visada pasiruošę patarti visais jums rūpimais klausimais.",
      "title": "Susisiekti"
    },
    "offices": "Mūsų biurai",
    "title": "Kontaktai"
  }
}
</i18n>
